import { Divider } from "@mui/material";
import React from "react";
import { CartContext } from "../../contex/CartProvider";

const ItemsOverview = () => {
  const { cart } = React.useContext(CartContext);

  return (
    <div>
      <div className="md:w-2/3 m-auto mb-10 md:mb-0 md:mt-12 max-h-[350px] md:max-h-[450px] overflow-y-scroll	">
        {cart.map((item, i) => (
          <div key={i} className="">
            <div className="w-[200px] md:w-[256px] m-auto  text-center py-4 bg-grey/10 rounded-lg font-bold text-lg md:text-xl">
              {item.part_number}
            </div>
            {cart.length - 1 !== i && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  height: "62px",
                  width: "4px",
                  borderRight: "2px solid gray",
                  margin: "auto",
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ItemsOverview;
